import { SpeakingMonitoringStage } from 'api';

export const getSpeakingMonitoringStageName = (stageType: SpeakingMonitoringStage): string => {
  const stageTypeNames: Record<SpeakingMonitoringStage, string> = {
    [SpeakingMonitoringStage.First]: 'First',
    [SpeakingMonitoringStage.Second]: 'Second',
    [SpeakingMonitoringStage.Third]: 'Third',
    [SpeakingMonitoringStage.Fourth]: 'Fourth',
    [SpeakingMonitoringStage.Fifth]: 'Fifth',
  };
  return stageTypeNames[stageType] ?? '-';
};
